import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { LOOKS, bySlug, staffById } from "../../data/salon";
import { useScrollScrub } from "../../lib/motion";

/**
 * Vertical scroll drives the strip sideways: --p (0..1) from useScrollScrub
 * translates the rail, so the gallery reads as one continuous move.
 */
export default function Gallery() {
  const track = useScrollScrub();

  return (
    <section className="gal" ref={track}>
      <div className="gal__head wrap wrap--wide">
        <div>
          <span className="eyebrow eyebrow--violet">THE WORK</span>
          <h2 className="gal__title">نمونه‌کارها</h2>
        </div>
        <Link to="/portfolio" className="tlink">
          همه نمونه‌کارها<span className="tlink__arrow">←</span>
        </Link>
      </div>

      <div className="gal__viewport">
        <div className="gal__rail">
          {LOOKS.map((l) => {
            const svc = bySlug(l.serviceSlug);
            const who = staffById(l.staffId);

            return (
              <Link key={l.id} to="/portfolio" className="gcard">
                <Photo src={l.photo} ratio="3 / 4" className="ph--hover" tint="soft" />
                <span className="gcard__meta">
                  <span className="gcard__title">{l.title}</span>
                  <span className="gcard__by">{who.name} · {svc.name}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
